'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HIDE_RESULTS = exports.SHOW_RESULTS = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactTranslate = require('@gandi/react-translate');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classname = require('classname');

var _classname2 = _interopRequireDefault(_classname);

var _reactCustomScrollbars = require('react-custom-scrollbars');

require('./ResultsBlock.css');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SHOW_RESULTS = exports.SHOW_RESULTS = 'open';
var HIDE_RESULTS = exports.HIDE_RESULTS = 'close';

var ResultsBlock = function (_PureComponent) {
  (0, _inherits3.default)(ResultsBlock, _PureComponent);
  (0, _createClass3.default)(ResultsBlock, [{
    key: 'areShopsEquals',
    value: function areShopsEquals(a, b) {
      return a.map(function (shop) {
        return shop.id;
      }).join(',') === b.map(function (shop) {
        return shop.id;
      }).join(',');
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.childElements[this.props.selectedId]) {
        this.scrollToShop(this.props.selectedId);
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (this.childElements[this.props.selectedId] && this.props.selectedId !== prevProps.selectedId) {
        this.scrollToShop(this.props.selectedId);
      } else if (this.childElements[this.props.selectedId]) {
        if (!this.areShopsEquals(this.props.diorShops, prevProps.diorShops) || !this.areShopsEquals(this.props.otherShops, prevProps.otherShops)) {
          this.scrollToShop(this.props.selectedId);
        }
      }
    }
  }]);

  function ResultsBlock(props) {
    (0, _classCallCheck3.default)(this, ResultsBlock);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ResultsBlock.__proto__ || (0, _getPrototypeOf2.default)(ResultsBlock)).call(this, props));

    _this.handleZoomIn = function () {
      var _this$props = _this.props,
          maxZoom = _this$props.maxZoom,
          onZoom = _this$props.onZoom,
          zoom = _this$props.zoom;

      if (onZoom && zoom < maxZoom) {
        onZoom(zoom + 1);
      }
    };

    _this.handleZoomOut = function () {
      var _this$props2 = _this.props,
          onZoom = _this$props2.onZoom,
          zoom = _this$props2.zoom;

      if (onZoom && zoom > 0) {
        onZoom(zoom - 1);
      }
    };

    _this.htmlElement = document.getElementsByTagName('html')[0];
    _this.scrollElement = null;
    _this.childElements = {};
    return _this;
  }

  (0, _createClass3.default)(ResultsBlock, [{
    key: 'onChildInit',
    value: function onChildInit(id, element) {
      if (element) {
        this.childElements[id] = element;
      }
    }
  }, {
    key: 'onScrollInit',
    value: function onScrollInit(element) {
      if (element) {
        this.scrollElement = element;
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var __ = this.props.__;

      return _react2.default.createElement(
        'div',
        { className: (0, _classname2.default)('ResultsBlock', this.props.displayResults), style: this.props.styles },
        _react2.default.createElement(
          'h2',
          { className: 'sr-only' },
          __('ResultsBlock|Results')
        ),
        _react2.default.createElement(
          _reactCustomScrollbars.Scrollbars,
          {
            hideTracksWhenNotNeeded: true,
            renderTrackVertical: function renderTrackVertical(props) {
              return _react2.default.createElement('div', (0, _extends3.default)({}, props, { className: 'Scrollbars__track-vertical' }));
            },
            renderThumbVertical: function renderThumbVertical(props) {
              return _react2.default.createElement('div', (0, _extends3.default)({}, props, { className: 'Scrollbars__thumb-vertical' }));
            },
            renderView: function renderView(props) {
              return _react2.default.createElement('div', (0, _extends3.default)({}, props, { className: 'Scrollbars__view' }));
            },
            ref: this.onScrollInit.bind(this)
          },
          this.props.diorShops.length === 0 && this.props.otherShops.length === 0 && _react2.default.createElement(
            'div',
            { className: 'ResultsBlock__title' },
            _react2.default.createElement(
              'span',
              { role: 'alert' },
              this.props.tooFar ? __('ResultsBlock|Too far') : __('ResultsBlock|No result')
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'ResultsBlock__buttons' },
            _react2.default.createElement(
              'button',
              {
                'aria-label': __('ResultsBlock|Fewer results, zoom in'),
                className: 'button button--light',
                onClick: this.handleZoomIn
              },
              __('ResultsBlock|Fewer results')
            ),
            _react2.default.createElement(
              'button',
              {
                'aria-label': __('ResultsBlock|More results, zoom out'),
                className: 'button button--light',
                onClick: this.handleZoomOut
              },
              __('ResultsBlock|More results')
            )
          ),
          this.props.diorShops.length > 0 && _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'h3',
              { className: 'ResultsBlock__title' },
              __('ResultsBlock|Dior boutiques')
            ),
            this.props.diorShops.map(function (item, index) {
              return _react2.default.createElement(
                'div',
                {
                  key: item.id,
                  ref: _this2.onChildInit.bind(_this2, item.id),
                  className: (0, _classname2.default)({ 'last': index === _this2.props.diorShops.length - 1 })
                },
                item.element
              );
            })
          ),
          this.props.otherShops.length > 0 && _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'h3',
              { className: 'ResultsBlock__title' },
              __('ResultsBlock|Other shops')
            ),
            this.props.otherShops.map(function (item, index) {
              return _react2.default.createElement(
                'div',
                {
                  key: item.id,
                  ref: _this2.onChildInit.bind(_this2, item.id),
                  className: (0, _classname2.default)({ 'last': index === _this2.props.otherShops.length - 1 })
                },
                item.element
              );
            })
          )
        )
      );
    }
  }, {
    key: 'scrollToShop',
    value: function scrollToShop(id) {
      if (this.scrollElement) {
        this.scrollElement.scrollTop(this.childElements[id].offsetTop);
      }
    }
  }]);
  return ResultsBlock;
}(_react.PureComponent);

ResultsBlock.propTypes = {
  __: _propTypes2.default.func.isRequired, // @see https://github.com/Gandi/react-translate
  diorShops: _propTypes2.default.array,
  displayResults: _propTypes2.default.string,
  styles: _propTypes2.default.object,
  maxZoom: _propTypes2.default.number,
  onZoom: _propTypes2.default.func,
  otherShops: _propTypes2.default.array,
  selectedId: _propTypes2.default.string,
  tooFar: _propTypes2.default.bool,
  zoom: _propTypes2.default.number
};

ResultsBlock.defaultProps = {
  diorShops: [],
  displayResults: HIDE_RESULTS,
  styles: {},
  maxZoom: 18,
  otherShops: [],
  selectedId: null,
  tooFar: false,
  zoom: 2
};

exports.default = (0, _reactTranslate.withTranslator)()(ResultsBlock);


//////////////////
// WEBPACK FOOTER
// ./~/ui-kit/src/components/ResultsBlock/ResultsBlock.js
// module id = 1173
// module chunks = 0